import React from 'react';
import { createPortal } from 'react-dom';
import '../AdminDashboard.css';
import './AdminFirebaseActions.css';

function getDisplayName(employee) {
  if (employee.firstName && employee.lastName) {
    return `${employee.firstName} ${employee.lastName}`;
  }
  return employee.displayName || employee.email || 'Utilisateur';
}

function getInitials(employee) {
  if (employee.firstName && employee.lastName) {
    return `${employee.firstName[0]}${employee.lastName[0]}`.toUpperCase();
  }
  const name = employee.displayName || employee.email || 'U';
  return typeof name === 'string'
    ? name.split(' ').map((n) => n[0]).join('').toUpperCase()
    : 'U';
}

export function EmployeesListModal({ open, onClose, employees, loading, onRefresh }) {
  if (!open) return null;

  const employeeOnly = employees.filter((u) => u.role === 'employee');

  return createPortal(
    <div className="employees-modal-overlay active" onClick={onClose} role="presentation">
      <div
        className="employees-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-labelledby="employees-modal-title"
      >
        <div className="employees-modal-header">
          <h2 id="employees-modal-title">Liste des employés</h2>
          <button type="button" className="employees-modal-close" onClick={onClose} aria-label="Fermer">
            ×
          </button>
        </div>

        <div className="employees-modal-toolbar">
          <button type="button" className="export-btn" onClick={onRefresh} disabled={loading}>
            {loading ? 'Chargement…' : 'Recharger'}
          </button>
        </div>

        <div className="employees-modal-body">
          <div className="stats-overview">
            <div className="stat-card">
              <div className="stat-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                  <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
              </div>
              <div className="stat-content">
                <h3>{employees.length}</h3>
                <p>Total utilisateurs</p>
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                  <circle cx="12" cy="7" r="4" />
                </svg>
              </div>
              <div className="stat-content">
                <h3>{employeeOnly.length}</h3>
                <p>Employés</p>
              </div>
            </div>
          </div>

          {loading ? (
            <p className="employees-modal-empty">Chargement des employés…</p>
          ) : employeeOnly.length === 0 ? (
            <p className="employees-modal-empty">
              Aucun employé trouvé. Les employés apparaîtront ici une fois inscrits.
            </p>
          ) : (
            <div className="employees-grid">
              {employeeOnly.map((employee) => (
                <div key={employee.id} className="employee-card">
                  <div className="card-header">
                    <div className="employee-avatar">{getInitials(employee)}</div>
                    <div className="employee-info">
                      <h3>{getDisplayName(employee)}</h3>
                      <div className="employee-status">
                        <span className="status-badge" style={{ backgroundColor: '#20b2aa' }}>
                          Actif
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="card-content">
                    <div className="personal-details">
                      <h4>Détails personnels</h4>
                      <div className="detail-item">
                        <strong>Email :</strong> {employee.email || 'Non renseigné'}
                      </div>
                      <div className="detail-item">
                        <strong>Prénom :</strong> {employee.firstName || 'Non renseigné'}
                      </div>
                      <div className="detail-item">
                        <strong>Nom :</strong> {employee.lastName || 'Non renseigné'}
                      </div>
                      <div className="detail-item">
                        <strong>Poste :</strong> {employee.position || 'Non renseigné'}
                      </div>
                      <div className="detail-item">
                        <strong>Rôle :</strong> {employee.role || 'employee'}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
}
